import { defineComponent } from "vue";
import orderService from "@/services/order.service";
import dateFormatService from "@/services/date-format.service";
import VueCookie from 'vue-cookie'
import moment from "moment";
import { useToast } from "vue-toastification";
import Paginate from 'vuejs-paginate-next';
import decimalService from "@/services/decimal.service";

export default defineComponent({
   name: "customer-purchase-history-list",
   setup() {
      const toast = useToast();
      return { toast }
   },
   components: {
      paginate: Paginate,
   },
   filters: {
      date(val) {
         return val ? moment(val).format("YYYY-MM-DD") : "";
      },
   },
   data() {
      return {
         customer: {
            id_customer: '',
            customer_name: '',
            email: '',
            mobile_no: '',
         },
         order_by: 'DESC',
         orders: null,
         searchData: {
            id_customer: '',
            order_by: ''
         },

         page: 1,
         currentPage: 1,
         fromItems: 1,
         toItems: 1,
         totalItems: 0,
         perPage: 0,
         totalPage: 0,
      };
   },
   methods: {
      changePage: function (pageNum) {
         this.getPurchaseHistoryList(pageNum,this.order_by);
      },
      formatDate(date: string) {
         return dateFormatService.formatDate(date);
      },
      formatDateTime(date: string) {
         return dateFormatService.formatDateTime(date);
      },
      formatDatePeriod(date: string) {
         return dateFormatService.formatDatePeriod(date);
      },
      convertTo2Decimal(number) {
         return decimalService.formatNumberTo2Decimal(number);
      },
      getPurchaseHistoryList(pageNum, order_by = 'DESC') {
         const loader = this.$loading.show();
         this.order_by = order_by;
         this.searchData.id_customer = this.customer.id_customer;
         this.searchData.order_by = order_by;
         orderService
            .getCustomerPurchaseHistory(pageNum, this.searchData)
            .then((res) => {
               loader.hide();
               this.orders = res.data.data;

               this.currentPage = res.data.current_page;
               this.fromItems = res.data.from;
               this.toItems = res.data.to;
               this.totalItems = res.data.total;
               this.totalPage = res.data.last_page;
               this.perPage = res.data.per_page;
            })
            .catch((err) => {
               console.log(err);
               loader.hide();
            });
      },
   },
   mounted() {
      this.customer = JSON.parse(VueCookie.get('user'));
      this.getPurchaseHistoryList(this.currentPage);
   },
});
